<div class="luminary-maintenance">
  <div class="luminary-maintenance__date">
    <sit-icon [icon]="Icon.luminary_sign" [sizeClass]="'icon-size-28'" alt="Próxima revisión"></sit-icon>
    <div class="luminary-maintenance__date-text">
      <span class="luminary-maintenance__date-value">
        {{ properties?.nextMaintenanceDate || '--/--/--' }}
      </span>
      <span class="luminary-maintenance__date-label">
        {{ properties?.nextMaintenanceLabel || 'Próxima revisión' }}
      </span>
    </div>
  </div>

  <div class="luminary-maintenance__action">
    <sit-icon [icon]="Icon.settings_key_white" [sizeClass]="'icon-size-20'" alt="Programar mantenimiento"></sit-icon>
    <span>Programar Mantenimiento</span>
  </div>
</div>
